import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { QuoteService } from '../services/quote.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Quote } from '../../shared/models/quote.interface';
import { FileService } from '../../shared/services/file.service';
import { QuoteBase } from '../../shared/models/quote.base.interface';
import { QuoteSummary } from '../models/quote.summary.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { PrintLanguageDialog } from '../../shared/controls/print-language-dialog/print.language.dialog';
import { MaterialsListDialogComponent } from '../../shared/controls/materials-list-dialog/materials-list-dialog.component';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent extends AbstractBiditComponent {
  quoteSummary: QuoteSummary = {
    quote: {} as Quote,
    areaSummaries: []
  };
  quoteId: number;

  constructor(@Inject(LOCALE_ID) private locale: string,
    private quoteService: QuoteService, private dialog: MatDialog,
    deviceDetectorService: DeviceDetectorService,
    private router: Router, private fileService: FileService, private route: ActivatedRoute) {
    super(deviceDetectorService);
  }

  init() {
    this.route.paramMap.subscribe(params => {
      let id = params.get('quoteId');
      this.quoteId = parseInt(id);
      this.refreshQuote(this.quoteId);
    });
  }

  get noteLabel(): string {
    if (this.locale == 'es')
      return `${$localize`Notes`} (${this.quoteSummary.quote.notes?.length})`;

    return `Notes (${this.quoteSummary.quote.notes?.length})`;
  }

  get documentLabel(): string {
    if (this.locale == 'es')
      return `${$localize`Documents`} (${this.quoteSummary.quote.documents?.length})`;

    return `Documents (${this.quoteSummary.quote.documents?.length})`;
  }

  get acknowledgementLabel(): string {
    if (this.locale == 'es')
      return `${$localize`Acknowledgements`} (${this.quoteSummary.quote.quoteAcknowledgements?.length})`;

    return `Acknowledgements (${this.quoteSummary.quote.quoteAcknowledgements?.length})`;
  }

  refreshQuote(quoteId: number) {
    this.quoteService.getQuote(quoteId)
      .subscribe({
        next: (data) => {
          this.quoteSummary = data;
        },
        error: (error: string) => this.onError(error)
      });
  }

  deleteQuote(): void {
    var proceed = confirm($localize`Are you sure?`);
    if (!proceed) return;

    this.quoteService.deleteQuote(this.quoteSummary.quote.quote_ID)
      .subscribe({
        next: (data) => {
          this.router.navigate(['/quote/']);
        },
        error: (error: string) => this.onError(error)
      });
  }

  quoteUpdated(quote: Quote) {
    this.refreshQuote(quote.quote_ID);
  }

  materialList(): void {
    const dialogRef = this.dialog.open(MaterialsListDialogComponent, {
      data: {
        quote_ID: this.quoteId,
        assignedToEmail: this.quoteSummary.quote.quoteAssignments[0]?.assignedTo.email,
        dealer_IDIBranchEmail: this.quoteSummary.quote.idiBranch_Email
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;

      this.isRequesting = true;

      this.quoteService.materialList(this.quoteId, result.lang, result.showJobAddress)
        .subscribe({
          next: (x) => {
            this.isRequesting = false;
            this.fileService.downloadFile(x, 'MaterialList.pdf');
          },
          error: (error: string) => this.onError(error)
        });
    });
  }

  eSignatureStatus(): void {
    this.isRequesting = true;

    this.quoteService.geteSignatureStatus(this.quoteSummary.quote.quote_ID)
      .subscribe({
        next: (x) => {
          this.refreshQuote(this.quoteSummary.quote.quote_ID);
          this.isRequesting = false;

          if (x == -3) {
            window.alert('e-signature statuses update is complete...');
          }
          else if (x == -2) { // "consent_required") {
            var consentResult = window.confirm('We are not able to send the e-signature request at this time because you have not given consent to send e-signature requests.  Press OK if you want to be redirected to the DocuSign site to give consent.');
            if (consentResult == true) {
              this.quoteService.getConsentURL().subscribe({
                next: (urlData) => {
                  var consentURL = urlData.redirectURL;
                  // window.open(consentURL, '_blank')
                  //location(consentURL)
                  window.location.href = urlData.redirectURL;

                  // this.router.navigate([consentURL]);
                },
                error: (error: string) => {
                  this.onError(error);
                },
                complete: () => {

                }
              });
            }

          }
          else if (x == -1) { //  "envelope_locked") {
            window.alert('We are not able to update the e-signature request at this time because the request is not in an updatable status.  The receiptent(s) have either signed or declined the request, or the request has expired.');
          }
          else {
            window.alert('e-signature statuses update is complete...');
          }
        },
        error: (error: string) => { this.onError(error); },
        complete: () => {
          this.isRequesting = false;
        }
      });
  }
}
